import { KbsEntityLookupWrapper } from 'components/Lookups/KbsEntityLookups/KbsEntityLookupWrapper';
import { LookupSelect } from 'components/Lookups/LookupSelect';
import React from 'react';
import { LookupModel } from 'types/graphql';

interface IProps {
  includeDeleted?: boolean;
  selectedId?: number | null;
  onSelect: (item?: LookupModel) => void;
}

export const KbsEntitySelect = (props: IProps): JSX.Element => {
  return (
    <KbsEntityLookupWrapper includeDeleted={props.includeDeleted}>
      {({ queryDocument, queryVariables, extractLookups }) => (
        <LookupSelect
          extractLookupItems={extractLookups}
          queryDocument={queryDocument}
          queryVariables={queryVariables}
          selectedId={props.selectedId}
          onSelect={props.onSelect}
        />
      )}
    </KbsEntityLookupWrapper>
  );
};
